import { cn } from '../utils/cn';

interface SkeletonLoaderProps {
  className?: string;
}

/** Shimmering placeholder block. Size it with width/height utilities. */
export const SkeletonLoader = ({ className }: SkeletonLoaderProps) => {
  return <div className={cn('skeleton', className)} aria-hidden="true" />;
};
